import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.035 21.968a4.015 4.015 0 01-3.11-1.566L.508 15.405a2.007 2.007 0 01.18-2.85 2.006 2.006 0 012.83.201l4.134 4.676a.422.422 0 00.362.18.462.462 0 00.36-.16L24.652.515a2.007 2.007 0 012.89 2.77L11.085 20.602a3.893 3.893 0 01-3.05 1.365z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
